"use client";
import React from "react";

const Button = ({
  variant = "primary",
  children,
  className = "",
  ...props
}) => {
  const baseClasses =
    "px-8 py-4 text-lg font-semibold rounded-lg transition-all cursor-pointer duration-[0.2s] text-white min-w-[180px]";
  
  const variantClasses = {
    primary: "bg-indigo-500 border-none hover:bg-indigo-600 active:bg-indigo-700 active:scale-[0.98]",
    secondary: "border-2 border-solid border-white border-opacity-20 hover:bg-white hover:bg-opacity-10 active:bg-opacity-20 active:scale-[0.98]",
  };
  
  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;